import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	FormGroup,
	Label,
} from "reactstrap";

import {
	qualityAdd,
	model_close,
} from "../../../store/Masters/quality/actions";

class AddQuality extends Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.handleValidSubmit = this.handleValidSubmit.bind(this);
	}

	handleValidSubmit(event, values) {
		this.props.qualityAdd(values, this.props.history);
	}
	render() {
		var data = this.props.rowdata;
		const isEdit = data && data.id && data.id > 0 ? true : false;
		return (
			<React.Fragment>
				<Modal
					isOpen={this.props.model}
					backdrop="static"
					centered
					size="lg">
					<ModalHeader toggle={() => this.props.model_close()}>
						{isEdit ? "EDIT QUALITY" : "ADD QUALITY"}
					</ModalHeader>
					<AvForm
						className="form-horizontal"
						onValidSubmit={this.handleValidSubmit}>
						<ModalBody>
							<Row className="justify-content-center">
								<Col md={10}>
									<Row className="justify-content-center">
										<Col md={9}>
											<FormGroup row>
												<Col md={4}>
													<Label
														htmlFor="QualityName"
														className="col-form-label float-right">
														Quality Name
													</Label>
												</Col>
												<Col md={8}>
													<AvField
														name="name"
														type="text"
														value={
															isEdit
																? data.name
																: ""
														}
														className="form-control"
														id="QualityName"
														placeholder="Enter Quality Name"
														errormessage=" Please provide a valid Quality Name"
														validate={{
															required: {
																value: true,
															},
														}}
													/>
												</Col>
											</FormGroup>
											<FormGroup>
												<AvField
													className="form-control"
													type="hidden"
													value={data.id}
													id="id"
													name="id"
												/>
											</FormGroup>
										</Col>
									</Row>
								</Col>
							</Row>

							<ModalFooter>
								<Button
									type="button"
									className="btn btn-danger"
									color="light"
									onClick={() => this.props.model_close()}>
									Close
								</Button>
								<Button
									type="submit"
									className="btn btn-primary"
									color="primary">
									Save
								</Button>
							</ModalFooter>
						</ModalBody>
					</AvForm>
				</Modal>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { qualitylist, model, rowdata } = state.quality;
	return { qualitylist, model, rowdata };
};

export default connect(mapStatetoProps, {
	qualityAdd,
	model_close,
})(AddQuality);
